import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useGlobalStore } from '@/stores';
import { ordersApi } from '@/api';
import { OrderCartBody, OrderCartResponse } from '@/api/orders/orders.types.ts';

export const useOrderCart = (
  options?: Partial<
    UseMutationOptions<OrderCartResponse, AxiosError, OrderCartBody>
  >,
) => {
  const store = useGlobalStore();
  const contactEmployeeId = store.contactEmployeeId;
  if (!contactEmployeeId) {
    throw new Error('Contact employee ID is not set');
  }
  return useMutation<OrderCartResponse, AxiosError, OrderCartBody>({
    mutationFn: (body) =>
      ordersApi.orderCart(contactEmployeeId, body).then((res) => res.data),
    ...options,
  });
};
